import React, { useMemo } from 'react';

import OrderTemplatesEdit from '@components/shared/order_templates/OrderTemplatesEdit';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import { useOperatorOrderTemplateService } from '@hooks/operator/order_templates/useOperatorOrderTemplateService';
import useRecordMerchantSync from '@hooks/operator/useRecordMerchantSync';

interface SalesChannelRecord {
  id: string;
  name?: string | null;
  extra_name?: string | null;
  [key: string]: unknown;
}

// 此頁只負責 edit 路由（/order_templates/:id/edit）；new 路由走 New.jsx。
const OperatorOrderTemplateEdit: React.FC = () => {
  const { merchantSalesChannels, currentMerchant } = useOperatorData();
  const { handleRecordLoaded, merchantDataLoading } = useRecordMerchantSync();

  // currentMerchant 會被 useRecordMerchantSync 切到 record 所屬 merchant。
  // Reference data 永遠跟著 currentMerchant 走。
  // 把 useOperatorOrderTemplateService 綁定到 currentMerchant?.id（post-sync），
  // 確保 update 用對的 merchant — 而不是 header 上的 merchant（可能在 sync 前殘留）。
  const service = useOperatorOrderTemplateService({ merchantId: currentMerchant?.id });

  // shared 期待 { label, value }（與舊 service.getSalesChannels 回傳同形），
  // 把 context 內的 SalesChannelRecord[] 轉成下拉選項格式。
  const salesChannelOptions = useMemo(() => {
    return (merchantSalesChannels as SalesChannelRecord[] | undefined ?? []).map((channel) => ({
      label: channel.name || channel.extra_name || '',
      value: channel.id,
      ...channel,
    }));
  }, [merchantSalesChannels]);

  // wrapper 由 onOrderTemplateLoaded 拿到 record's merchant_id 後同步 context，
  // 整個過程 merchantDataLoading 為 true 擋住 form 渲染，避免閃錯的下拉。
  return (
    <OrderTemplatesEdit
      role="operator"
      service={service}
      salesChannels={salesChannelOptions}
      onOrderTemplateLoaded={handleRecordLoaded}
      merchantDataLoading={merchantDataLoading}
    />
  );
};

export default OperatorOrderTemplateEdit;
